const ferries = {
  ferry: "フェリー", // translated
  ferries: "フェリー", // translated
  selectOriginPort: "元のポートを選択します", // translated
  selectDestPort: "宛先ポートを選択します", // translated
  continue: "続く", // translated
  viewTimetables: "時刻表を見る", // translated
  operator: "オペレーター", // translated
  cabin: "キャビン", // translated
  cabins: "キャビン", // translated
  place: "場所", // translated
  places: "場所", // translated
  seat: "シート", // translated
  seats: "席", // translated
  seating: "座席", // translated
  deckSpace: "デッキスペース", // translated
  compulsory: "義務", // translated
  departure: "出発", // translated
  total: "合計", // translated
  back: "戻る", // translated
  next: "次", // translated
  duration: "間隔", // translated
  return: "戻る", // translated
  prebook: "事前予約", // translated
  travelInfo: "旅行情報", // translated
  book: "本", // translated
  adults: "大人", // translated
  child: "子供", // translated
  seniors: "シニア", // translated
  senior: "シニア", // translated
  to: "に", // translated
  passenger: "乗客", // translated
  details: "詳細", // translated
  currencyForTickets: "これらのチケットの通貨は次のとおりです。", // translated
  seatsError: "乗客数は定員と一致しません。", // translated
  title: "タイトル", // translated
  firstName: "ファーストネーム", // translated
  lastName: "苗字", // translated
  email: "Eメール", // translated
  phone: "電話", // translated
  dateOfBirth: "生年月日", // translated
  placeOfBirth: "出生地", // translated
  groupLeader: "グループリーダー", // translated
  isRequired: "が必要です", // translated
  charactersOnly: "文字のみ", // translated
  latinCharactersAndSpacesOnly: "ラテン文字とスペースのみ", // translated
  validEmail: "有効なメールではありません", // translated
  atLeastOneAdult: "少なくとも大人 1 名が必要です。", // translated
  atLeastOneSenior: "少なくとも1人の上級者が必要です。", // translated
  toastAlert: "以下のフォーム内の間違いをすべて修正してください。", // translated
  backToFerriesList: "フェリー一覧に戻る", // translated
  bestPrice: "ベストプライス", // translated
  fastest: "最速", // translated
  beforeDeparture: "出発する前に", // translated
  perPerson: "一人当たり", // translated
  notAvailableForOnlineBooking: "ネット予約不可", // translated
  hurryLimitedAvailability: "急いで！限られた可用性", // translated
  berth: "バース", // translated
  berths: "バース", // translated
  sumOfSelectionNotEqualToPersons: "選択した合計が乗客数と等しくありません", // translated
  attemptToBook: "合計で予約しようとしました", // translated
  seatsWhenYouHave: "座席があるときは", // translated
  passengersTravelling: "旅行中の乗客", // translated
  withReturn: "往復航空券付き", // translated
  pleaseCorrectYourSelection: "選択を修正してください", // translated
  pleaseSelectUpTo: "まで選択してください", // translated
  accommodationTypes: "宿泊施設のタイプ", // translated
  selectionPrices: "セレクションの価格", // translated
  yourCurrentTicket: "現在のチケットの種類は次のとおりです", // translated
  upgradeTo: "へのアップグレード", // translated
  wouldYouLikeToUpgrade: "チケットの種類をアップグレードしますか?", // translated
  backToTicketTypes: "チケットの種類に戻る", // translated
  originPort: "発信元ポート", // translated
  destinationPort: "宛先ポート", // translated
  outboundDate: "出発日", // translated
  inboundDate: "到着日", // translated
  passengers: "乗客", // translated
  hasReturn: "戻ってきました", // translated
  passportNumber: "パスポート番号", // translated
  passportExpiryDate: "パスポートの有効期限", // translated
  passportPlaceOfIssue: "パスポート発行地", // translated
  passportStartDate: "パスポートの開始日", // translated
  cityCode: "市外局番", // translated
};



export default ferries;
